import { render } from "./stageSetting.vue?vue&type=template&id=3230675c&scoped=true"
import script from "./stageSetting.vue?vue&type=script&lang=js"
export * from "./stageSetting.vue?vue&type=script&lang=js"

import "./stageSetting.vue?vue&type=style&index=0&id=3230675c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3230675c"]])

export default __exports__